import { render, staticRenderFns } from "./PortalEnd.vue?vue&type=template&id=701ae8dd&"
import script from "./PortalEnd.vue?vue&type=script&lang=ts&"
export * from "./PortalEnd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports